import {
    getSettingUsers,
    updateSettingUser,
} from "../../services/SettingService";

import {
    CONFIRMED_GET_SETTINGS,
    CONFIRMED_UPDATE_SETTING,
} from "../actions/SettingType";

import {
    handleSuccess,
    showErrorAlert,
    handleError,
} from "../../services/ErrorHandlingService";


export function getSettingUsersAction() {
    return async (dispatch) => {
        try {
            const response = await getSettingUsers();

            if (response?.status === 200 && response.data?.status === "success") {
                const settings = response.data.data;
                dispatch({
                    type: CONFIRMED_GET_SETTINGS,
                    payload: settings,
                });
                return settings;
            } else {
                handleError("Failed to get settings");
            }
        } catch (error) {
            console.error("API Error:", error);
            showErrorAlert("Failed to get settings");
        }
    };
}


export function updateSettingUserAction(setting_update) {
    return async (dispatch) => {
        try {
            const response = await updateSettingUser(setting_update);

            if (response && response.status === 200 && response.data.status === "success") {
                dispatch({
                    type: CONFIRMED_UPDATE_SETTING,
                    payload: setting_update.setting_update, // Pass the array directly
                });

                handleSuccess("Settings updated successfully");
            } else {
                showErrorAlert("Failed to update settings");
            }
        } catch (error) {
            console.error("API Error:", error.response || error);
            showErrorAlert("Failed to update settings");
        }
    };
}

